const clinic = (state = [], action) => {
    switch (action.type) {
        case "GET_CLINIC":
            return action.payload;
            break;
        default:
            return state;
            break;
    }
}

const clinicTotalPage = (state = 0, action) => {
    switch (action.type) {
        case "GET_TOTAL_PAGE_CLINIC":
            return action.payload;
            break;
        default:
            return state;
            break;
    }
}

export { clinic, clinicTotalPage } ;